export const check_access = (type,scopes) => {
    // if(!scopes){
    //     return 0
    // }
    // if(Object.values(scopes).find(element => element === "All scopes" || element === type))
    //     return true
    return true
}